<div class="card-wrapper" [ngClass]="isTabletSizeScreen ? 'responsive-layout' : ''">
  <div class="row mx">
    <h4><strong>Topic presenti</strong></h4>
    <p class="p-mini">Clicca su un topic per evidenziarlo nel testo</p>
    <div class="" *ngIf="topics$ | async as topics">
      <p style="padding: 0;" [ngClass]="isTabletSizeScreen ? 'col-lg-4' : 'col-lg-12'" class="col-xs-6 col-sm-6 col-md-4 singlecheckbox custom_check checkbox-topic" *ngFor="let topic of topics; let i = index">
        <span class="col-xs-10 col-sm-10"><label class="fakelabel">{{formatLabel(topic.wrapper.tipo.label)}}</label></span>
        <input class="col-xs-2 col-sm-10" name="{{topic.wrapper.tipo?.label}}" id="topic-{{topic.wrapper.tipo.id}}-{{i}}" type="checkbox" (change)="switch($event, topic)">
        <label for="topic-{{topic.wrapper.tipo.id}}-{{i}}" style="top: -10px;"></label>
      </p> 
    </div>
  </div>
  <div class="row mx">
    <h4><strong>Sezioni documento</strong></h4>
    <p class="p-mini">Clicca su una sezione per evidenziarla nel testo</p>
    <div class="" *ngIf="sections$ | async as sezioni">
      <p style="padding: 0;" [ngClass]="isTabletSizeScreen ? 'col-lg-4' : 'col-lg-12'" class="col-xs-6 col-sm-6 col-md-4 singlecheckbox custom_check checkbox-section" *ngFor="let sezione of sezioni; let i = index">
        <span class="col-xs-10 col-sm-10"><label class="fakelabel">{{formatLabel(sezione.wrapper.tipo.label)}}</label></span>
        <input class="col-xs-2 col-sm-10" name="{{sezione.wrapper.tipo?.label}}" id="sezione-{{sezione.wrapper.tipo.id}}-{{i}}" type="checkbox" (change)="switch($event, sezione)">
        <label for="sezione-{{sezione.wrapper.tipo.id}}-{{i}}" style="top: -10px;"></label>
      </p>
    </div>
  </div>
  <div class="row mx">
    <h4><strong>Entità</strong></h4>
    <p class="p-mini">Clicca su una entit&aacute; per evidenziarla nel testo</p>
    <div class="" *ngIf="entities$ | async as entities">
      <p style="padding: 0;" [ngClass]="isTabletSizeScreen ? 'col-lg-4' : 'col-lg-12'" class="col-xs-6 col-sm-6 col-md-4 singlecheckbox checkbox-entity custom_check" *ngFor="let entity of entities; let i = index">
        <span class="col-xs-10 col-sm-10"><label class="fakelabel">{{formatLabel(entity.wrapper.tipo.label)}}</label></span>
        <input class="col-xs-2 col-sm-10" name="{{entity.wrapper.tipo?.label}}" id="entity-{{entity.wrapper.tipo.id}}-{{i}}" type="checkbox" (change)="switch($event, entity)">
        <label for="entity-{{entity.wrapper.tipo.id}}-{{i}}" style="top: -10px;"></label>
      </p>
    </div>
  </div>
</div>

